import { FC } from 'react';
import Link from 'next/link';
import Text from '@components/common/text';
import Icon from '@components/common/assets';
import ResponsiveModal from '@components/_atoms/ResponsiveModal';
import { useRequiredItems } from '@repository/match';
import { CardStatus } from '..';
import { AccLightStatusTypeEnum } from '@domain/rs/match/PositionAccStatusRs';
import { ProfileInfo } from '@domain/constant/profile/ProfileOverlayType';
import { ProfileItemType } from '@domain/constant/profileRequirementType';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';

import { V2RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ProfileCardProps {
  positionSn: number;
}
const ProfileCard: FC<ProfileCardProps> = ({ positionSn }) => {
  const { data } = useRequiredItems(positionSn);

  if (!data) return null;

  return (
    <div className={cx('wrapper')}>
      <Link
        className={cx('profileCard', { isNeed: !data?.isProfileComplete })}
        href={V2RouteUrl.PROFILE}
        target="_blank"
      >
        <div className={cx('cardTitle')}>내 프로필</div>

        <CardStatus
          status={data?.isProfileComplete ? AccLightStatusTypeEnum.COMPLETED : AccLightStatusTypeEnum.BEFORE_APPLY}
        />
      </Link>

      <div className={cx('itemList', { isComplete: data?.isProfileComplete })}>
        <ResponsiveModal.ScrollArea className={cx('scrollArea')} innerClassName={cx('scrollInner')} maxHeight={392}>
          {data?.requiredItems?.map(({ type, title, description }) => (
            <Link
              key={type}
              href={{ pathname: V2RouteUrl.PROFILE, query: { name: getProfileQuery(type) } }}
              target="_blank"
            >
              <div className={cx('item')}>
                <div className={cx('info')}>
                  <Text fontStyle={FontStyle.B2_B} color={Colors.C_COOL_GRAY_80}>
                    {title}
                  </Text>
                  {!!description && (
                    <Text fontStyle={FontStyle.B3_M} color={Colors.C_COOL_GRAY_60}>
                      {description}
                    </Text>
                  )}
                </div>

                <div className={cx('link')}>
                  작성하기
                  <Icon name="arrowRightLight" width={24} height={24} />
                </div>
              </div>
            </Link>
          ))}
        </ResponsiveModal.ScrollArea>
      </div>
    </div>
  );
};

export default ProfileCard;

const getProfileQuery = (type: ProfileItemType) => {
  switch (type) {
    case 'BASIC':
      return ProfileInfo.BASIC_INFO;
    case 'EDUCATION':
      return ProfileInfo.EDU;
    case 'CAREER':
      return ProfileInfo.CAREER;
    case 'PROJECT':
      return ProfileInfo.PROJECT;
    case 'KNOWLEDGE_AND_SKILL':
      return ProfileInfo.SKILL;
    case 'PREFERENTIAL':
      return ProfileInfo.MILITARY_PREFERENCE;
    case 'FILE':
      return ProfileInfo.ATTACHED_FILE;
    case 'PRIZE':
      return ProfileInfo.PRIZE;
    case 'EXPERIENCE':
      return ProfileInfo.EXPERIENCE;
    default:
      return '';
  }
};
